import flagRu from "@/shared/assets/img/flags/ru.png";
import flagKk from "@/shared/assets/img/flags/kz.png";
import flagEn from "@/shared/assets/img/flags/en.png";

export interface LanguageOption {
  value: "ru" | "kk" | "en";
  label: string;
  flag: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: "ru", label: "Русский", flag: flagRu },
  { value: "kk", label: "Қазақша", flag: flagKk },
  { value: "en", label: "English", flag: flagEn },
];
